import React from "react";
import { useNavigate } from "react-router-dom";
import { DevIcons } from "./DevDashboardIcons";
import {
  DevInfoSkeleton,
  DevSkillsSkeleton,
  DevSupportSkeleton,
} from "./DevDashboardSkeleton";

const DevSidebarInfo = ({
  developerInfo = {},
  skills = [],
  support = {},
  loading = {},
}) => {
  const navigate = useNavigate();

  return (
    <aside className="dev-sidebar">
      {/* 1. Developer Information Card */}
      {loading?.info ? (
        <DevInfoSkeleton />
      ) : (
        <div className="dev-sidebar-card">
        <div className="dev-sidebar-header">
          <h3 className="dev-sidebar-title">Developer Information</h3>
          <button
            type="button"
            className="dev-edit-btn"
            onClick={() => navigate("/management-listing", { state: "profile" })}
            title="Edit Profile"
            aria-label="Edit Profile"
          >
            <DevIcons.Edit size={13} color="#2563eb" />
            <span>Edit</span>
          </button>
        </div>

        <div className="dev-info-list">
          <div className="dev-info-row">
            <span className="dev-info-label">Status</span>
            <span className="dev-status-pill status-available">
              <span className="dev-status-dot" />
              {developerInfo.status}
            </span>
          </div>

          <div className="dev-info-row">
            <span className="dev-info-label">Member Since</span>
            <span className="dev-info-val">{developerInfo.memberSince}</span>
          </div>

          <div className="dev-info-row">
            <span className="dev-info-label">Last Updated</span>
            <span className="dev-info-val">{developerInfo.lastUpdated}</span>
          </div>

          <div className="dev-info-row">
            <span className="dev-info-label">Email</span>
            <a
              href={`mailto:${developerInfo.email}`}
              className="dev-info-val dev-info-email-link"
            >
              {developerInfo.email}
            </a>
          </div>

          <div className="dev-info-row">
            <span className="dev-info-label">Total Machines</span>
            <span className="dev-info-val">{developerInfo.totalMachines}</span>
          </div>

          <div className="dev-info-row">
            <span className="dev-info-label">Published Machines</span>
            <span className="dev-info-val">
              {developerInfo.publishedMachines}
            </span>
          </div>

          <div className="dev-info-row">
            <span className="dev-info-label">Draft Machines</span>
            <span className="dev-info-val">{developerInfo.draftMachines}</span>
          </div>

          <div className="dev-info-row">
            <span className="dev-info-label">Active Workflows</span>
            <span className="dev-info-val">
              {developerInfo.activeWorkflows}
            </span>
          </div>

          <div className="dev-info-row">
            <span className="dev-info-label">Total Runs (All Time)</span>
            <span className="dev-info-val">
              {developerInfo.totalRunsAllTime}
            </span>
          </div>

          <div className="dev-info-row">
            <span className="dev-info-label">Total Earnings (USD)</span>
            <span className="dev-info-val">{developerInfo.totalEarnings}</span>
          </div>

          <div className="dev-info-row border-0">
            <span className="dev-info-label">Average Rating</span>
            <span className="dev-info-val dev-sidebar-rating">
              <DevIcons.Star size={14} color="#f59e0b" fill="#f59e0b" />
              <span>
                {developerInfo.averageRating} ({developerInfo.ratingCount})
              </span>
            </span>
          </div>
        </div>
      </div>
      )}

      {/* 2. Skills / Categories Card */}
      {loading?.skills ? (
        <DevSkillsSkeleton />
      ) : (
        <div className="dev-sidebar-card">
          <div className="dev-sidebar-header">
            <h3 className="dev-sidebar-title">Skills / Categories</h3>
          </div>

          <div className="dev-skills-wrap">
            {skills.map((skill, index) => (
              <span key={index} className="dev-skill-chip">
                {skill}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* 3. Support & Notes Card */}
      {loading?.support ? (
        <DevSupportSkeleton />
      ) : (
        <div className="dev-sidebar-card dev-support-notes-card">
          <div className="dev-sidebar-header">
            <h3 className="dev-sidebar-title">Support & Notes</h3>
          </div>

          <div className="dev-support-list">
            <div className="dev-support-item">
              <DevIcons.Mail size={16} className="dev-support-icon" />
              <a
                href={`mailto:${support.email}`}
                className="dev-support-text dev-support-email"
              >
                {support.email}
              </a>
            </div>

            <div className="dev-support-item">
              <DevIcons.Clock size={16} className="dev-support-icon" />
              <span className="dev-support-text">
                Support Hours: {support.supportHours}
              </span>
            </div>

            <div className="dev-support-item">
              <DevIcons.Clock size={16} className="dev-support-icon" />
              <span className="dev-support-text">
                Response Time: {support.responseTime}
              </span>
            </div>

            <div className="dev-support-item align-items-start">
              <DevIcons.FileText
                size={16}
                className="dev-support-icon mt-1"
              />
              <div className="dev-support-text">
                <div>Best Regards,</div>
                <div>SoftQube</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </aside>
  );
};

export default DevSidebarInfo;
